import { env } from '@/lib/env'
import { escapeHtmlAttribute, widgetApiBaseUrl } from '@/components/CampaignWidgetManager/widgetPreviewTokens'
import { resolvePublicAppUrl } from '@/lib/publicAppUrl'

export type CampaignLandingEmbedSnippetInput = {
  campaignId: number
  appUrl?: string
  apiUrl?: string
}

export function landingEmbedScriptUrl(apiBase?: string): string {
  const base = (apiBase ?? widgetApiBaseUrl()).replace(/\/+$/, '')
  return `${base}/js/landing-embed.js?v=${encodeURIComponent(env.landingEmbedAssetVersion)}`
}

export function buildCampaignLandingEmbedContainerId(campaignId: number): string {
  if (!Number.isFinite(campaignId) || campaignId < 1) {
    throw new Error('ID da campanha inválido para gerar o container de instalação.')
  }
  return `legalprime-campanha-${Math.trunc(campaignId)}`
}

/**
 * Snippet completo para colar no site do cliente (div + script).
 * Usa o ID da campanha; o slug é resolvido em runtime pelo landing-embed.js.
 */
export function buildCampaignLandingEmbedSnippet(input: CampaignLandingEmbedSnippetInput): string {
  const campaignId = Math.trunc(input.campaignId)
  if (!Number.isFinite(campaignId) || campaignId < 1) {
    throw new Error('ID da campanha é obrigatório para gerar o snippet de instalação.')
  }

  const appUrl = (input.appUrl ?? resolvePublicAppUrl()).replace(/\/+$/, '')
  if (!appUrl) {
    throw new Error(
      'URL pública do app não configurada. Defina VITE_PUBLIC_APP_URL ou abra o painel no domínio do frontend.',
    )
  }

  const apiUrl = (input.apiUrl ?? widgetApiBaseUrl()).replace(/\/+$/, '')
  if (!apiUrl) {
    throw new Error('URL da API não configurada. Defina VITE_API_BASE_URL.')
  }

  const containerId = buildCampaignLandingEmbedContainerId(campaignId)
  const scriptUrl = landingEmbedScriptUrl(apiUrl)

  const safeCampaignId = escapeHtmlAttribute(String(campaignId))
  const safeApp = escapeHtmlAttribute(appUrl)
  const safeApi = escapeHtmlAttribute(apiUrl)
  const safeScript = escapeHtmlAttribute(scriptUrl)
  const safeContainer = escapeHtmlAttribute(containerId)

  return `<div id="${safeContainer}"></div>
<script
  src="${safeScript}"
  data-lp-landing-embed-bootstrap="1"
  data-campaign-id="${safeCampaignId}"
  data-app-url="${safeApp}"
  data-api-url="${safeApi}"
  data-container="${safeContainer}"
></script>`
}
